import { Col, Container, Row } from 'react-bootstrap'
import { GetStartedHeroContainer } from './style'
import { useTranslation } from 'react-i18next'

function GetStartedHero() {
  const { t } = useTranslation()

  return (
    <GetStartedHeroContainer>
      <Container className="h-100">
        <Row className="h-100">
          <Col md={4} xs={8}>
            <div className="get-header-content">
              <h1>{t('started_header_title')}</h1>
            </div>
          </Col>
        </Row>
      </Container>
    </GetStartedHeroContainer>
  )
}

export default GetStartedHero
